/** Error thrown by AcquaintApiClient when an API request fails, carrying the
 *  HTTP status code and raw response body so callers can branch on them.
 *  `message` is set to the response body so existing callers that read
 *  err.message (e.g. getErrorMessage) continue to behave as before. */
export class ApiError extends Error {
  public readonly status: number;
  public readonly body: string;

  constructor(body: string, status: number) {
    super(body);
    this.name = "ApiError";
    this.status = status;
    this.body = body;

    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
